import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/migration.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "migrating-to-aepcampaignclassic-reference"
    }}>{`Migrating to AEPCampaignClassic reference`}</h1>
    <p>{`This document is a reference comparison of AEPCampaignClassic (3.x) APIs against their equivalent APIs in ACPCampaignClassic (2.x) for an iOS mobile application implementation.`}</p>
    <p>{`The AEPCampaignClassic extension is implemented purely in Swift and is compatible with the AEPCore Swift SDK. To ensure a smooth transition from the ACPCampaignClassic SDK, there are no major changes on the API names or definition. For more details, follow the migration guide below for your Swift or Objective-C mobile application. If explanation beyond showing API differences is necessary, it will be captured as a note within that API's section.`}</p>
    <h2 {...{
      "id": "aepcampaignclassic-classes"
    }}>{`AEPCampaignClassic classes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP (3.x)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Objective-C)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ACP (2.x)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Primary Class (Module)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`CampaignClassic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`AEPMobileCampaignClassic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ACPCampaignClassic`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "aepcampaignclassic-apis"
    }}>{`AEPCampaignClassic APIs`}</h2>
    <h3 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=extension-version" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=extension-version" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=extension-version" mdxType="Tabs" />
    <h3 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=register-extension" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=register-extension" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=register-extension" mdxType="Tabs" />
    <h3 {...{
      "id": "registerdevice"
    }}>{`registerDevice`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=register-device" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=register-device" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=register-device" mdxType="Tabs" />
    <h3 {...{
      "id": "tracknotificationclick"
    }}>{`trackNotificationClick`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=track-notification-click" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=track-notification-click" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=track-notification-click" mdxType="Tabs" />
    <h3 {...{
      "id": "tracknotificationreceive"
    }}>{`trackNotificationReceive`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=track-notification-receive" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=track-notification-receive" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=track-notification-receive" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      